import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import "./Button.sass";

function Button({ children, type, className, onClick, ...rest }) {
  const classes = classNames("btn", className);
  return (
    <button className={classes} type={type} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}

Button.defaultProps = {
  type: "submit",
  children: "",
  className: "",
  onClick: () => {},
};

Button.propTypes = {
  type: PropTypes.string,
  children: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
};

export default Button;
